/**
 * @generated SignedSource<<2c67bd4e5e024a77cf97403601bab895>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Metric_metric$data = {
  readonly label: string;
  readonly url: string | null;
  readonly value: string | null;
  readonly " $fragmentType": "Metric_metric";
};
export type Metric_metric$key = {
  readonly " $data"?: Metric_metric$data;
  readonly " $fragmentSpreads": FragmentRefs<"Metric_metric">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Metric_metric",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "PipelineMetric",
  "abstractKey": null
};

(node as any).hash = "ae8f411ba59b2aedb877bbed4ae6063d";

export default node;
